var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicondark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34961 51.5147C19.7286 54.7208 31.4661 62.9805 31.4661 62.9805V20.0518L9.34961 27.279C11.5776 38.4731 9.34961 51.5147 9.34961 51.5147Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57812 25.8659C7.82795 19.9429 6.57812 16.1934 6.57812 16.1934C6.57812 16.1934 8.64305 15.65 15.979 9.99859C14.8922 14.7262 16.2506 18.5843 16.2506 18.5843L21.9563 16.5194C21.9563 16.5194 23.4779 11.4114 21.9563 6.24912C28.1512 4.12985 31.4659 0 31.4659 0V17.4432L6.57812 25.8659Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0618 9.67231C48.1486 14.3999 46.7901 18.2581 46.7901 18.2581L41.0844 16.1931C41.0844 16.1931 39.5629 11.0852 41.0844 5.92285L47.0618 9.67231Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4658 17.4434V20.0517L53.6366 27.279L56.408 25.8661L31.4658 17.4434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicondark);
export default __webpack_public_path__ + "static/media/favicondark.335010b58c3f83947c3fa7df3901cf91.svg";
export { ForwardRef as ReactComponent };